import { ValueObject } from '@nx-smartmonkey/shared/domain';

interface ProjectViewConstraintsProps {
  distance: boolean;
  weight: boolean;
  volume: boolean;
  time_windows: boolean;
  provide_requires: boolean;
  max_services: boolean;
  pickups: boolean;
  min_distance: boolean;
  max_distance: boolean;
  min_time: boolean;
  max_time: boolean;
  max_delivery_time: boolean;
  reward: boolean;
  cluster: boolean;
}

export class ProjectViewConstraints extends ValueObject<ProjectViewConstraintsProps> {
  get distance(): boolean {
    return this.props.distance;
  }
  set distance(distance: boolean) {
    this.props.distance = distance;
  }
  get weight(): boolean {
    return this.props.weight;
  }
  set weight(weight: boolean) {
    this.props.weight = weight;
  }
  get volume(): boolean {
    return this.props.volume;
  }
  set volume(volume: boolean) {
    this.props.volume = volume;
  }
  get time_windows(): boolean {
    return this.props.time_windows;
  }
  set time_windows(timeWindows: boolean) {
    this.props.time_windows = timeWindows;
  }
  get provide_requires(): boolean {
    return this.props.provide_requires;
  }
  set provide_requires(provideRequires: boolean) {
    this.props.provide_requires = provideRequires;
  }
  get max_services(): boolean {
    return this.props.max_services;
  }
  set max_services(maxServices: boolean) {
    this.props.max_services = maxServices;
  }
  get pickups(): boolean {
    return this.props.pickups;
  }
  set pickups(pickups: boolean) {
    this.props.pickups = pickups;
  }
  get min_distance(): boolean {
    return this.props.min_distance;
  }
  set min_distance(minDistance: boolean) {
    this.props.min_distance = minDistance;
  }
  get max_distance(): boolean {
    return this.props.max_distance;
  }
  set max_distance(maxDistance: boolean) {
    this.props.max_distance = maxDistance;
  }
  get min_time(): boolean {
    return this.props.min_time;
  }
  set min_time(minTime: boolean) {
    this.props.min_time = minTime;
  }
  get max_time(): boolean {
    return this.props.max_time;
  }
  set max_time(maxTime: boolean) {
    this.props.max_time = maxTime;
  }
  get max_delivery_time(): boolean {
    return this.props.max_delivery_time;
  }
  set max_delivery_time(maxDeliveryTime: boolean) {
    this.props.max_delivery_time = maxDeliveryTime;
  }
  get reward(): boolean {
    return this.props.reward;
  }
  set reward(_reward: boolean) {
    this.props.reward = _reward;
  }
  get cluster(): boolean {
    return this.props.cluster;
  }
  set cluster(_reward: boolean) {
    this.props.cluster = _reward;
  }
  private constructor(props: ProjectViewConstraintsProps) {
    super(props);
  }
  static create(props: ProjectViewConstraintsProps): ProjectViewConstraints {
    return new ProjectViewConstraints(props);
  }
}
